<template>
  <section class="clearfix Pagination">
    <button
      class="Previous"
      @click="
        this.plansData.page.currentPage !== 1
          ? [ gotoPage(this.plansData.page.currentPage - 1), scrollToTop() ]
          : null
      "
    ></button>
    <span> {{ this.plansData.page.currentPage }}</span
    >/
    <span>{{ totalPage }}</span>
    <button
      class="Next"
      @click="
        this.plansData.page.currentPage !== totalPage
          ? [ gotoPage(this.plansData.page.currentPage + 1), scrollToTop() ]
          : null
      "
    ></button>
  </section>
  
</template>

<script>
import { useDataContext } from '@/composable/plans';
export default {
  name: 'PaginationComponent',
  setup() {
    return useDataContext();
  },
  methods: {
    gotoPage(pageNo) {
      this.plansData.page.currentPage = pageNo;
    },
    refresh() {
      window.location.reload();
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  computed: {
    totalPage: function () {
      let roundedNo = Math.ceil(
        this.plansData.filteredPlans.length === 0 ? 1 : this.plansData.filteredPlans.length / this.plansData.page.pageSize
      );
      return roundedNo;
    },
  },
};
</script>

<style>

</style>
